export const components_index = ['components.index']
export const components_create = ['components.create']
export const components_edit = ['components.edit']

export default [].concat(
    components_index,
    components_create,
    components_edit
)
